module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"TypoRecognition":{"message":"Měli jste na mysli"}},"de":{"TypoRecognition":{"message":"Haben Sie gemeint"}},"sk":{"TypoRecognition":{"message":"Mali ste na mysli"}}}')
  delete Component.options._Ctor
}
